import { render } from "./Sidebar.vue?vue&type=template&id=bec33f9c&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__